import React from "react";
import axios from "axios";
import { HomeURL, BackendCall, DETAILS } from "../s_data/file";



const getProfileInfo = () => {
  // headers
  const headersList = {
    "x-api-key": "C#nS%!#l$k8MdasibVmE5U&f(a?",
    "Content-Type": "application/x-www-form-urlencoded",
  };

  // request config
  return axios.request({
    url: `${BackendCall}/profile`,
    method: "POST",
    headers: headersList,
    data: "",
    withCredentials: true,
  });
};



export { getProfileInfo };